import React, { memo } from 'react';
import { Button, Form, Row, Col } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import DateRangePicker from '../../../../components/DateRangePicker';
import { CustomCol, StyledSelect } from '../style';
import { DeletedStatus , PlayerStatus} from "../userConstant"
import { getDateDaysAgo } from '../../../../utils/dateFormatter';
import DateFilterDropdown from "../../../../components/CustomDateFilterOptions";


const UsersFilter = memo(({
  search,
  setSearch,
  phoneNumber,
  setPhoneNumber,
  kycOptions,
  setKycOptions,
  kycLabels,
  setAffiliateSearch,
  setUserId,
  setLimit,
  setPage,
  setOrderBy,
  setSortBy,
  setState,
  state,
  resetColumns,
  filterRef,
  customColSetting,
  setSelectedFilter,
  selectedFilter,
  onResetDateFiltered,
  deletedFilter, setDeletdFilter,
  playerStatus, setPlayerStatus,
  promoCode,
  setPromoCode,
}) => {
  const resetFilters = () => {
    setSearch('');
    setAffiliateSearch('');
    setUserId('');
    setLimit(15);
    setPhoneNumber('');
    setPage(1);
    setOrderBy('userId');
    setSortBy('desc');
    setKycOptions('');
    onResetDateFiltered();
    setPromoCode('');
    resetColumns();

    // setState([
    //   {
    //     startDate: null,
    //     endDate: null,
    //     key: 'selection'
    //   }
    // ]);
  };

  console.log({deletedFilter , setDeletdFilter})

  return (
    <div className='FormsBg' ref={filterRef}>
      <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>
        <CustomCol xs={12} md={4} lg={3}>
          <Form.Control
            type='search'
            placeholder='Search Email, Name, Username'
            size='sm'
            value={search}
            onChange={(event) =>
              setSearch(
                event.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
              )}
            className="mb-2 mb-md-0"
          />
        </CustomCol>

        <CustomCol xs={12} md={4} lg={3}>
          <Form.Control
            type="search"
            placeholder="Search Promo Code"
            size="sm"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            className="mb-2 mb-md-0"
          />
        </CustomCol>

        <CustomCol xs={12} md={3} lg={3}>
          <Form.Control
            type='search'
            placeholder='Search Phone Number'
            size='sm'
            value={phoneNumber}
            onChange={(event) =>
              !isNaN(event.target.value) && setPhoneNumber(event.target.value)}
            className="mb-2 mb-md-0"
          />
        </CustomCol>

        <CustomCol xs={12} md={6} lg={2}>
          <Form.Select
            size="sm"
            onChange={(e) => {
              console.log(e.target.value)
              setDeletdFilter(e.target.value)
            }}
            value={deletedFilter}
            className="mb-2 mb-md-0"
          >
            {DeletedStatus && DeletedStatus?.map(
              ({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            )}
          </Form.Select>
        </CustomCol>

        <CustomCol xs={12} md={6} lg={2}>
          <Form.Select
            size="sm"
            onChange={(e) => {
              console.log(e.target.value)
              setPlayerStatus(e.target.value)
            }}
            value={playerStatus}
            className="mb-2 mb-md-0"
          >
            {PlayerStatus && PlayerStatus?.map(
              ({ label, value }) => (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            )}
          </Form.Select>
        </CustomCol>



        {/* <CustomCol xs={12} md={3} lg={2}>
          <StyledSelect
            onChange={(e) => setKycOptions(e.target.value)}
            value={kycOptions}
            size='sm'
            className="mb-2 mb-md-0"
          >
            {kycLabels.map((item) => {
              return <option key={`kyc Labels ${item?.value}`} value={item.value}>{item.label}</option>
            })}
          </StyledSelect>
        </CustomCol> */}

        <CustomCol xs={12} md={3} lg={2}>
          <DateFilterDropdown state={state}
            setState={setState} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
        </CustomCol>

        {selectedFilter === "custom" && <CustomCol xs={12} md={6} lg={3}>
          <DateRangePicker
            state={state}
            setState={setState}
            size="sm"
            className="mb-2 mb-md-0"
            player
            transaction
            bonus
          />
        </CustomCol>}


        <Row className="g-2 align-items-center mt-2 mt-md-0">
          <Col xs={12} className="d-flex justify-content-between align-items-center">
            <Button
              className="d-flex align-items-center btn-primary gap-2"
              style={{ height: '2.2rem', minWidth: 'max-content' }}
              size="sm"
              onClick={resetFilters}
            >
              <span>Reset Filters</span>
              <FontAwesomeIcon icon={faRedoAlt} />
            </Button>

            <div style={{ minWidth: '200px' }}>
              {customColSetting}
            </div>
          </Col>
        </Row>

      </Row>
    </div>
  );
});

export default UsersFilter;
